<script>
	import { onMount, afterUpdate } from 'svelte';
	import { apiUrl, files } from '../../share/stores';

	export let html;

	let div;
	let inputs;
	let submitButton;
	let submitDoneText;
	let submitFailedText;
	let submitable = false;
	let mailto = 'hello@burgeins.de';
	let mailSubject = 'from beweb';

	function initInputValidation(input, parent) {
		const required = parent.hasAttribute('required');
		const validation = parent.hasAttribute('validation') ? parent.getAttribute('validation') : false;

		let regex = required ? /(.|\s)+/gm : /(.|\s)*/gm;
		regex = parent.hasAttribute('regex') ? new RegExp(parent.getAttribute('regex')) : regex;
		switch (validation) {
			case 'mail':
				regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/gm
				break;
			case 'tel':
				//e.g. "+49 123 456 7890" or "01234567890"
				regex = /^(\+\d{2})?\s?(\d|\s){5,}$/gm
				break;
			case 'date':
				// dd.mm.yyyy:
				regex = /^\d{2}\.\d{2}.\d{4}$/gm
				break;
			case 'word':
				// pure letters possible in human Names like "Ágata Magalhães" or "Igor Mont'Alverne":
				regex = /^([A-Z\u00C0-\u00D6\u00D8-\u00DE])([a-z\u00DF-\u00F6\u00F8-\u00FF '&-]+)\ ?([A-Za-z\u00C0-\u00D6\u00D8-\u00DE\u00DF-\u00F6\u00F8-\u00FF '&-]+)$/gmi
		}
		return regex;
	}

	function checkInputsValidation() {
		inputs.forEach(input => {
			const parent = input.parentElement;
			const regex = initInputValidation(input, parent);

			function validateInput(invalidate = false) {
				const value = input.value;
				invalidate && parent.setAttribute('invalid', true);
				if (input.type === 'checkbox') {
					invalidate && parent.parentElement.setAttribute('invalid', true);
					if (input.checked) {
						parent.setAttribute('invalid', false);
						parent.parentElement.setAttribute('invalid', false);
					}
					checkIfSubmitable();
					return;
				}

				if (value.match(new RegExp(regex))) {
					parent.setAttribute('invalid', false);
				}
				checkIfSubmitable();
			}

			input.onchange = () => {
				validateInput(true);
			}
			input.onkeyup = () => {
				validateInput();
			}
		});
	}

	function checkIfSubmitable() {
		submitButton.classList.remove('submitted');
		submitButton.setAttribute('sending', false);
		// either there is one of all the fields, which is invalid
		const invalid = div.querySelector('[invalid="true"]');
		// or not all required fields where tested
		const requiredNotTested = div.querySelector('[required]:not([invalid="false"])');
		if (invalid || requiredNotTested) {
			submitButton.disabled = true;
			submitable = false;
			return;
		}
		submitButton.disabled = false;
		submitable = true;
	}

	function submitForm() {
		if (!submitable) {
			return;
		}
		submitable = false;
		submitButton.setAttribute('sending', true);

		const formData = new FormData();
		inputs.forEach(input => {
			switch (input.type) {
				case 'radio':
					formData.append(input.id, input.checked ? input.value : '');
					break;
				case 'checkbox':
					formData.append(input.id, input.checked);
					break;
				default:
					formData.append(input.id, input.value.trim());
			}
		});
		const honeyPot = div.querySelector('[name="a_password"]');
		formData.append('honeyPot', honeyPot.value);
		formData.append('mailto', mailto);
		formData.append('mailSubject', mailSubject);
		if($files.length > 0) {
			$files.forEach((file, index) => {
				formData.append('dataFile_' + index, file.data);
			})
		}
		const options = {
			method: 'POST', body: formData
		};
		fetch(apiUrl + '/email', options).then(response => {
			submitDoneText.style.display = 'block';
			submitButton.classList.add('submitted');
		}).catch(() => {
			submitFailedText.style.display = 'block';
		});
	}

	function setSubmitWidthForStyling() {
		submitButton.style.setProperty('--width', submitButton.getBoundingClientRect().width + 'px');
	}
	
	function initInputForm() {
		inputs = div.querySelectorAll('div > input, div > select, div > textarea, div input[type="checkbox"]');
		if(inputs.length <= 1) {
			requestAnimationFrame(initInputForm);
			return;
		}
		submitButton = div.querySelector('input[type="submit"]');
		submitDoneText = div.querySelector('.submit_done');
		submitDoneText.style.display = 'none';
		submitFailedText = div.querySelector('.submit_error');
		submitFailedText.style.display = 'none';
		submitButton.disabled = true;
		if (div.querySelector('[mailto]')) {
			mailto = div.querySelector('[mailto]').getAttribute('mailto');
		}
		if (div.querySelector('[mailSubject]')) {
			mailSubject = div.querySelector('[mailSubject]').getAttribute('mailSubject');
		}
		checkInputsValidation();
		submitButton.addEventListener('click', () => {
			submitForm();
		});
		
		setSubmitWidthForStyling();
		window.addEventListener('resize', () => {
			setSubmitWidthForStyling();
		})
	}
	
	onMount(() => {
		initInputForm();
	})
</script>

<div bind:this={div} class="input_form">
	<div class="inputform paddingbox">
		<slot/>
		<!--HoneyPot following BestPractice:
    		- Is hidden with CSS.
    		- Has an obscure but obviously fake name.
    		- Has a default value equivalent 0.
    		- Can't be filled by auto-complete
    		- Can't be navigated to via the Tab key. (See tabindex)
		-->
		<input type="text" name="a_password" style="display:none !important" tabindex="-1" autocomplete="off">
	</div>
</div>

<style global lang="scss">
	@import "../../style/variables";
	@import "../../style/mixins";
	
	.input_form {
		width: 100%;
		
		.inputform {
			display: flex;
			flex-wrap: wrap;
			background-color: #CCCCCC;
			color: black;

			.useCustomCss & {
				background: #7B7B7B;
				color: #FFF;
			}
			
			.inputform-background-image {
				.inputform-background-image {
					width: calc(100% + 8.875rem);
					height: 100%;
					margin-left: -8.875rem;
					background-position: right;
					background-repeat: no-repeat;
					background-size: cover;
				}

				+ .inputform-inputs {
					padding: $spacing-mobile*1.5 $spacing-mobile;
				}
			}
			
			> div {
				flex: 50% 1 1;
				background-repeat: no-repeat;
				background-size: cover;
				gap: 0.5em;
			}
			
			&-inputs {
				flex: 50% 1 1;
				display: flex;
				flex-wrap: wrap;
				padding: $spacing-mobile*2 0;
				
				@media screen and (min-width: $breakpoint-tablet) {
					padding-right: $spacing-mobile*3;
				}
				
				> span {
					flex: 100%;
				}

				p {
					margin-bottom: $spacing-mobile;
					@include font-px-to-rem(22, 28, 300);
				}
				
				> div {
					display: flex;
					flex-wrap: wrap;
					position: relative;

					> input[type=text],
					> select,
					> textarea {
						width: 100%;
						padding: 0.5em;
						border-style: solid;
						border-radius: 0.25em;
						border-color: black;

						.useCustomCss & {
							border-color: white;
						}
					}

					>input::-webkit-input-placeholder{
						color: black;

						.useCustomCss & {
							color: white;
						}
					}
					
					> h4 {
						@include font-px-to-rem(18,30,400);
						width: auto;
						padding: 0 0 0.5em 0;
						margin-bottom: .2em;
					}
					
					> div {
						width: 100%;
					}
					
					&[invalid="true"] > input {
						border-color: $color-burgeins-8;
					}
					
					> h4,
					> input[type=text],
					> textarea {
						font-weight: normal;
					}
					
					> h4 {
						text-transform: uppercase;
					}
					
					> input[type=text],
					> textarea {
						text-transform: none;
					}
				}
				
				.required {
					line-height: 3.5rem;
					margin-bottom: 0;
				}
				
				.required::after {
					content: "";
				}
				
				.required .required::after {
					content: "*";
					margin-left: .1em;
				}
				
				.width_33 {
					flex: 30% 1 1;
					
					&.single_line {
						margin-right: calc(100% / 3 * 2);
					}
				}
				
				.width_50 {
					flex: auto;
					
					&.single_line {
						margin-right: calc(100% / 2);
					}
				}
				
				.width_100 {
					flex: 100% 0 0;
				}
				
				.submit {
					flex: 100% 0 0;
				}
				
				input,
				label,
				select,
				textarea {
					text-transform: uppercase;
					background-color: #CCCCCC;
					color: black;

					.useCustomCss & {
						background: #7B7B7B;
						color: #FFF;
					}
				}

				textarea {
					resize: none;
				}

				input[type="submit"] {
					display: block;
					background-color: $color-burgeins-6;
					transition: box-shadow var(--animation-duration) ease-in-out;
					padding: 1em 3em;
					border-radius: $border-burgeins;
					border: none;

					&[disabled] {
						background-color: white;

						.useCustomCss & {
							background-color: black;
						}
					}
					
					&[sending="true"] {
						box-shadow: inset var(--width) 0 $color-burgeins-7;
						color: white;
					}
				}

				label {
					&[for*="privacy"] {
						line-height: 1em;

						div {
							padding-left: 0;
							display: inline;
							margin: 0 3px;
						}
					}
					&[for*="privacy"] p, &[for*="privacy"] a {
						text-transform: none;
						@include font-px-to-rem(14, 15, 300);
						margin-bottom: 0;
					}
					&[for*="privacy"] a {
						text-decoration: underline;
					}

					&[for*="gender"] {
						margin: 0 1em 0 .3em;
					}
				}
				
				.single_line {
					flex-wrap: nowrap;
					
					> input[type=checkbox] {
						margin-right: .5em;
					}
				}
			}
			.submit {
				> .submit_done,
				> .submit_error {
					flex-wrap: nowrap;
					margin-bottom: $spacing-mobile;
					
					&::before {
						content: "";
						mask-repeat: no-repeat;
						mask-size: 100%;
						width: 1em;
						height: 1em;
						margin-right: .5em;
						display: block;
						float: left;
						margin-top: .25em;
					}
				}
				
				> .submit_done::before {
					mask-image: url("../img/icons/IconCheckmark.svg");
					background-color: greenyellow;
				}
				
				> .submit_error::before {
					mask-image: url("../img/icons/IconCrossRed.svg");
					background-color: darkred;
				}
			}
			
			/* custom radio button */
			/* The container */
			.container {
				display: block;
				position: relative;
				padding-left: 35px;
				cursor: pointer;
				user-select: none;
			}
			/* Hide the browser's default radio button */
			.container input {
				position: absolute;
				opacity: 0;
				display: none;
				cursor: pointer;
			}
			/* Create a custom radio button */
			.checkmark {
				position: absolute;
				top: 50%;
				left: 0;
				height: 20px;
				width: 20px;
				background-color: white;
				border-radius: 50%;
				transform: translateY(-50%);
				
				.checkmark {
					margin-top: 0;
				}
			}
			/* Create the indicator (the dot/circle - hidden when not checked) */
			.checkmark:after {
				content: "";
				position: absolute;
				display: none;
			}
			/* Show the indicator (dot/circle) when checked */
			.container input:checked ~ .checkmark:after {
				display: block;
			}
			/* Style the indicator (dot/circle) */
			.container .checkmark:after {
				top: 4px;
				left: 4px;
				width: 12px;
				height: 12px;
				border-radius: 50%;
				background: black;
			}
		}
	}
</style>
